<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine> </BaseTopLine>
    <div class="tw-p-[15px_26px]">

      <ve-table
        v-if="sb1LoadStatus == 'success'"
        class="rest-style-table"
        :columns="columns"
        :table-data="sb1Data"
        :border-x="true"
        :border-y="true"
        :cell-style-option="cellStyleOption"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import Modal from "@/components/Modals.vue";
import EventBus from "@/event-bus.js";
import { VeTable } from "vue-easytable";
export default {
  components: {
    Modal,
    VeTable,
  },

  props: {},
  data() {
    return {
      updatedValues: {},
      dataForModal: {},
      editData: {},
      activeSelectRow: null,
      intervalInstance: null,
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (column.field == "secur_clients_ankets_status__status") {
            return row.secur_clients_ankets_status__style_class + " text-white";
          }
        },
      },
    };
  },
  methods: {
    clickLoadData(numPage) {
      this.getSb1All({
        params: {
          limit: 1000,
          page: numPage,
        },
      });
    },

    ...mapActions("sb1Module", ["getSb1All"]),
  },

    mounted() {
      clearInterval(this.intervalInstance);
      this.intervalInstance = setInterval(() => {
        this.getSb1All({ params: { page: 1, limit: 2000 } });
      }, 60000);
    },
    unmounted() {
      clearInterval(this.intervalInstance);
      this.intervalInstance = null;
    },

  created() {
    this.getSb1All({ params: { page: 1, limit: 2000 } });
  },
  computed: {
    ...mapState("sb1Module", [
      "sb1Data",
      "sb1LoadStatus",
      "paginationSb1StateParams",
    ]),
    ...mapState("translationModule", ["dataLang"]),
    ...mapGetters("sb1Module", ["numPages"]),

    fieldsTableSb1() {
      return [
        {
          title: "ID",
          field: "secur_clients_ankets__id",
          headerFilter: "input",
        },
        {
          title: "Дата",
          field: "secur_clients_ankets__created_at",
          headerFilter: "input",
        },
        {
          title: "Клиент",
          field: "secur_clients_ankets__client_id",
          headerFilter: "input",
        },
        { title: "ФИО Клиента", field: "clients__name", headerFilter: "input" },
        {
          title: "Тип проверки",
          field: "secur_groups__name",
          headerFilter: "input",
        },
        {
          title: "Статус",
          field: "secur_clients_ankets_status__status",
          headerFilter: "input",
          hozAlign: "center",
          mutator: (value, data) => {
            return {
              status: value,
              styleClass: data.secur_clients_ankets_status__style_class,
            };
          },
          formatter: (cell) => {
            let value = cell.getValue();

            if (value.styleClass)
              cell.getRow().getElement().classList.add(value.styleClass);
            return value.status;
          },
        },
      ];
    },

    columns() {
      return [
        {
          field: "secur_clients_ankets__id",
          key: "secur_clients_ankets__id",
          title: "ID",
          align: "center",
          width: "5%",
        },
        {
          field: "secur_clients_ankets__created_at",
          key: "secur_clients_ankets__created_at",
          title: "Дата",
          align: "center",
          width: "10%",
        },
        {
          field: "secur_clients_ankets__client_id",
          key: "secur_clients_ankets__client_id",
          title: "Клиент",
          align: "center",
          width: "5%",
        },
        {
          field: "clients__name",
          key: "clients__name",
          title: "ФИО Клиента",
          align: "center",
        },
        {
          field: "secur_groups__name",
          key: "secur_groups__name",
          title: "Тип проверки",
          align: "center",
        },
        {
          field: "secur_clients_ankets_status__status",
          key: "secur_clients_ankets_status__status",
          title: "Статус",
          align: "center",
          width: "10%",
        },
      ];
    },
  },
};
</script>
